<template>
  <div class="card">
    <a :href="post.url" class="media">
      <Media
        :images="{ smallMedia: post.media.url, altText: post.caption }"
        :sources="
          post.mediaType === 'VIDEO'
            ? [
                {
                  url: post.media.url,
                },
              ]
            : []
        "
        cover
      />

      <div class="hover">
        <span class="link">Shop Now</span>
      </div>
    </a>

    <div class="info">
      <span class="info__likes">{{ post.likeCount }} likes</span>
      <p class="info__caption">{{ post.caption }}</p>
      <Link :href="post.url" class="shop-now-link">Shop Now</Link>
    </div>
  </div>
</template>

<script>
import Media from "@/components/Media.vue";
import Link from "@/components/Link.vue";

export default {
  name: "UGCCard",
  components: {
    Media,
    Link,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  text-decoration: none;
}

.info {
  text-align: center;
  @include utility-label(15px);

  &__caption {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;

    * {
      display: inline;
    }
  }
}

.media {
  display: block;
  aspect-ratio: 4/5;
  object-fit: cover;
  max-width: 100%;
  margin-bottom: 12px;
  background: $color-grey-light;
  position: relative;

  &:hover {
    .hover {
      @include respond-above(md) {
        display: block;
      }
    }
  }

  .hover {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);

    .link {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      @include utility-button(13px);
      display: inline-block;
      color: $color-white;
      border-bottom: 1px solid $color-white;
      padding: 4px 0;
      text-transform: uppercase;
    }
  }
}

:deep(.media img),
:deep(.media video) {
  display: block;
  aspect-ratio: 4/5;
  object-fit: cover;
  max-width: 100%;
}

.shop-now-link {
  margin-top: 8px;
  display: inline-block;

  @include respond-above(lg) {
    display: none;
  }
}
</style>
